export default "__VITE_ASSET__Utic5Cx0__"